export const ejectErrorMessage = (error: string | any): string | undefined => {
  if (typeof error === 'string') return error;
  if (error?.response?.data?.message) return error.response.data.message;
  if (error?.message) return error.message;
  return undefined;
};
